module.exports = __webpack_public_path__ + "img/logo_thumb.4068ed85.png";